import React from 'react';
// @ts-ignore
import styles from './ManagerBasicData.module.scss';
import useLoading from '../../../../Base/Hooks/useLoading';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import apiClient from '../../../../../Services/ApiClient';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import useNotification from '../../../../../Hooks/useNotification.hook';

interface Props {
	workplaceId: string;
	defaultData: {
		onlineOrderTarget: string;
	};
	onUpdate: () => void;
}

const FORM_SCHEME: ItemScheme[] = [
	{
		type: MagicField.SELECT,
		key: 'onlineOrderTarget',
		title: 'component.generalForm.onlineOrderTarget',
		children: [
			{
				key: 'WORKPLACE_MEMBER',
				value: 'WORKPLACE_MEMBER',
				title:
					'component.generalForm.workplaceCaseTargetOptions.workplaceMember',
			},
			{
				key: 'WORKPLACE',
				value: 'WORKPLACE',
				title: 'component.generalForm.workplaceCaseTargetOptions.workplace',
			},
		],
		settings: {
			required: true,
		},
	},
];

const ManagerWorkplaceOnlineOrderTargetSetup: React.FC<Props> = ({
	workplaceId,
	defaultData,
	onUpdate,
}) => {
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleSubmit = async (values: any) => {
		setIsLoading(true);
		try {
			const response = await apiClient.patch(`/workplaces/${workplaceId}`, {
				onlineOrderTarget:
					values.onlineOrderTarget?.value || values.onlineOrderTarget,
			});
			if (response.status === 200) {
				showNotificationSuccess({
					content:
						'component.managerWorkplaceOnlineOrderTargetSetup.successMessage',
				});
				onUpdate();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<MagicForm
			formScheme={FORM_SCHEME}
			onSubmit={handleSubmit}
			defaultValues={defaultData}
		/>
	);
};

export default ManagerWorkplaceOnlineOrderTargetSetup;
